/**
 * Retour haptique : une petite vibration rend le feedback physique.
 * No-op silencieux si l'appareil ou le navigateur ne supporte pas — iOS
 * Safari notamment, où l'API n'existe pas (le feedback principal doit donc
 * toujours être visuel, le son et la vibration sont des bonus).
 */
export function haptic(pattern: number | number[] = 30) {
    try {
        navigator.vibrate?.(pattern);
    } catch {
        /* non supporté */
    }
}
